var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('Loader'),_c('el-aside',{attrs:{"width":"250px"}},[_c('div',{staticClass:"aside__wrapper",class:_vm.asideClass},[_c('Logo'),_vm._t("sidenav")],2)]),_vm._t("main")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }